// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".intro-box[data-v-8ca682b2]{flex:0 0 100%;height:calc(100vh - 246px);display:flex;align-items:center;justify-content:center;flex-direction:column}.title[data-v-8ca682b2]{margin-bottom:15px;font-size:21px}.icon-repository[data-v-8ca682b2]{font-size:96px;margin-bottom:32px}", ""]);
// Exports
module.exports = exports;
